import React, {useState, useEffect} from 'react';
import {Button, Row, Col} from 'reactstrap';

import './selectAccountSticky.scss';

const AccountRowComponent = (props) => {
  let item = props.account.replace(/^(.{3})(.*)$/, '$1-$2');

  return (
    <Row>
      <Col className='account-row-component' onClick={() => props.action(props.account)}>
        {item}
      </Col>
    </Row>
  );
};
export default AccountRowComponent;
